import { Component } from '@angular/core'

/** Shared placeholder rows for mobile lists that do not have restored data yet. */
@Component({
  selector: 'aw-list-skeleton',
  templateUrl: './list-skeleton.component.html',
  styleUrl: './list-skeleton.component.scss'
})
export class ListSkeletonComponent {
  protected readonly rows = [0, 1, 2, 3]
}
